import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalserviceinahemdabad() {



  const cardData =
  {
    keyword: ' Corporate Car Rental Services in Ahmedabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rental Services in Ahmedabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Car Rental Services in Ahmedabad, catering to the transportation needs of corporate offices, IT companies, manufacturing units, and business hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, industrial visits, business meetings, or VIP transportation, we offer seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Ahmedabad.',

    top: 'Top Places to Visit in Ahmedabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, located on the banks of the Sabarmati River, was the home of Mahatma Gandhi for over a decade and served as a major center for the Indian freedom movement. Visitors can explore Gandhi’s simple living quarters, archives of letters, photographs, and exhibits explaining India’s struggle for independence. The peaceful environment, museum, and historical displays make it a place of deep reflection and national pride."
  },
  {
    "title": "Sidi Saiyyed Mosque",
    "description": "The Sidi Saiyyed Mosque, built in 1573 during the Gujarat Sultanate period, is renowned for its iconic stone latticework windows known as the 'Sidi Saiyyed Jali'. These intricately carved screens depicting the famous ‘Tree of Life’ are considered masterpieces of Indo-Islamic art. The mosque offers visitors a chance to admire historic craftsmanship and experience one of Ahmedabad’s most recognized architectural symbols."
  },
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is a beautiful riverside development project that has transformed Ahmedabad’s waterfront into a vibrant public space. Featuring pedestrian walkways, gardens, cycling tracks, boating facilities, and event spaces, the riverfront is ideal for family outings, leisure walks, and evening relaxation. The well-maintained urban landscape and scenic views make it a preferred hangout spot for locals and tourists."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell, located just outside Ahmedabad, is a centuries-old five-story stepwell built in 1498 in Indo-Islamic architectural style. Known for its beautifully carved pillars, ornamental walls, and cooling subterranean design, the stepwell served as a resting place for travelers in earlier times. Today, it stands as an engineering and artistic marvel, offering visitors a glimpse into Gujarat’s architectural heritage."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is a large man-made lake that has evolved into one of Ahmedabad’s most popular recreational hubs. Surrounding the lake are amusement rides, toy trains, food stalls, a zoo, children’s play zones, and water activities, making it ideal for families. The illuminated musical fountain shows and clean walking paths make evenings at Kankaria lively and memorable."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1424 by Sultan Ahmed Shah, is one of the most impressive mosques in Gujarat. Constructed from yellow sandstone, it features beautifully carved pillars, grand prayer halls, and a harmonious blend of Hindu and Islamic architectural influences. Visitors can explore the expansive courtyard and admire the detailed stonework, reflecting the historical importance of early Ahmedabad."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in the world, preserving centuries of India’s weaving, dyeing, printing, and embroidery traditions. Exhibits include royal costumes, temple cloths, carpets, and antique fabrics displayed in well-curated galleries. Visitors can gain a deep understanding of India's rich textile heritage, craftsmanship, and cultural evolution."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "Auto World Vintage Car Museum houses one of India’s largest collections of classic automobiles, including limousines, sports cars, convertibles, and royal vehicles from Europe and America. Many cars belonged to Indian princely families and are preserved in running condition. The museum offers a nostalgic journey into the history of automotive engineering and luxury travel."
  },
  {
    "title": "Hutheesing Jain Temple",
    "description": "Built in 1848, Hutheesing Jain Temple is a beautifully crafted marble temple dedicated to Lord Dharmanath. The temple features ornate carvings, elaborately decorated domes, and peaceful prayer halls that showcase the artistic traditions of Jain architecture. It is a serene spiritual destination and a remarkable example of Ahmedabad’s religious heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is Ahmedabad’s famous city square known for its unique transformation throughout the day: a bustling vegetable market in the morning, a jewelry hub during the day, and a thriving street food destination at night. Visitors can enjoy traditional Gujarati snacks, sweets, and freshly prepared dishes, making it a must-visit spot for food lovers seeking authentic local flavors."
  }
],


"services": [
  {
    "name": "Ahmedabad Corporate Car Rental",
    "description": "Ahmedabad Corporate Car Rental offers premium car rental services for businesses, including a wide selection of vehicles ranging from sedans to SUVs. Whether for employee commutes, corporate events, or executive travel, the service ensures timely, professional transportation with well-maintained cars and experienced chauffeurs, making it an ideal choice for companies in Ahmedabad."
  },
  {
    "name": "Business Car Hire Ahmedabad",
    "description": "Business Car Hire Ahmedabad provides executive-level car rental solutions for business professionals. With luxury sedans, SUVs, and high-end vehicles available, the service ensures smooth, comfortable, and reliable transportation for business meetings, airport transfers, and client visits. Professional chauffeurs and flexible scheduling make it a preferred choice for corporate travel."
  },
  {
    "name": "Employee Car Rental Ahmedabad",
    "description": "Employee Car Rental Ahmedabad offers customized car rental solutions designed for employee transportation. This service includes reliable, comfortable vehicles for daily commutes, flexible route planning, and professional drivers. Ideal for companies that need a consistent and safe travel option for their employees in Ahmedabad."
  },
  {
    "name": "Company Car Lease Ahmedabad",
    "description": "Company Car Lease Ahmedabad provides long-term vehicle leasing solutions for businesses in Ahmedabad. This service offers flexible leasing terms, a variety of vehicle options, and full fleet management, allowing companies to streamline their transport needs without the upfront costs of purchasing vehicles."
  },
  {
    "name": "Monthly Corporate Car Rental Ahmedabad",
    "description": "Monthly Corporate Car Rental Ahmedabad offers businesses an affordable and hassle-free solution for long-term car rental. With a fleet of well-maintained vehicles, the service ensures consistent availability for daily employee commutes, client visits, and business meetings, while providing easy billing and flexible rental terms."
  },
  {
    "name": "Corporate Fleet Ahmedabad",
    "description": "Corporate Fleet Ahmedabad offers complete fleet management and rental solutions for businesses. From sedans and SUVs to shuttles, the service provides a wide range of vehicles, ensuring companies have the right transport options for daily employee commutes, business travel, and special events."
  },
  {
    "name": "Executive Car Rental Ahmedabad",
    "description": "Executive Car Rental Ahmedabad offers high-end luxury vehicles for executives and senior management. The service includes premium sedans, SUVs, and chauffeurs who are well-trained in corporate protocols. Ideal for business executives who require comfortable and professional transportation for meetings, travel, and client visits."
  },
  {
    "name": "Sedan Car Rental Ahmedabad",
    "description": "Sedan Car Rental Ahmedabad provides comfortable, reliable, and economical sedans for corporate transport. Ideal for business travel, office commutes, or client meetings, the service offers well-maintained vehicles with experienced chauffeurs, ensuring a smooth and safe travel experience for employees and clients."
  },
  {
    "name": "SUV Car Rental Ahmedabad",
    "description": "SUV Car Rental Ahmedabad offers spacious, high-comfort SUVs for corporate travel. Perfect for team travel, senior executives, or long-distance business trips, the service ensures reliable and comfortable transportation, with professional chauffeurs ensuring a safe and efficient ride."
  },
  {
    "name": "Luxury Car Rental Ahmedabad",
    "description": "Luxury Car Rental Ahmedabad provides a premium selection of high-end vehicles for corporate and executive travel. Whether for special events, VIP client meetings, or business conferences, the service ensures that clients travel in luxury with experienced chauffeurs and impeccable vehicles."
  },
  {
    "name": "Affordable Corporate Car Rental Ahmedabad",
    "description": "Affordable Corporate Car Rental Ahmedabad provides cost-effective yet reliable car rental services for companies. This service is designed for businesses that require efficient transportation without compromising on safety, comfort, or punctuality, making it ideal for startups and mid-sized companies."
  },
  {
    "name": "Airport Corporate Car Rental Ahmedabad",
    "description": "Airport Corporate Car Rental Ahmedabad offers seamless airport transfer services for businesses. With timely pickups, experienced chauffeurs, and a fleet of well-maintained vehicles, the service ensures that employees and executives travel to and from Ahmedabad Airport with ease, comfort, and efficiency."
  },
  {
    "name": "Outstation Corporate Car Hire Ahmedabad",
    "description": "Outstation Corporate Car Hire Ahmedabad provides long-distance travel solutions for businesses needing transportation for meetings, conferences, or site visits outside Ahmedabad. The service includes comfortable vehicles, experienced drivers, and interstate permits, ensuring safe and smooth outstation travel."
  },
  {
    "name": "Chauffeur Driven Car Rental Ahmedabad",
    "description": "Chauffeur Driven Car Rental Ahmedabad offers professionally driven car rental services for businesses and executives. With a fleet of sedans, SUVs, and luxury cars, the service provides flexible transportation options for business travel, client visits, or employee commutes, all handled by highly skilled chauffeurs."
  },
  {
    "name": "Staff Transportation Car Rental Ahmedabad",
    "description": "Staff Transportation Car Rental Ahmedabad provides efficient and reliable transport for employees in Ahmedabad. With a fleet of cars, vans, and buses, the service offers scheduled routes and flexible trip planning, ensuring that employees reach their destination on time and in comfort."
  }
],

"tableData": [
  ["Ahmedabad Corporate Car Rental", "Business Car Hire Ahmedabad"],
  ["Employee Car Rental Ahmedabad", "Company Car Lease Ahmedabad"],
  ["Monthly Corporate Car Rental Ahmedabad", "Corporate Fleet Ahmedabad"],
  ["Executive Car Rental Ahmedabad", "Sedan Car Rental Ahmedabad"],
  ["SUV Car Rental Ahmedabad", "Luxury Car Rental Ahmedabad"],
  ["Affordable Corporate Car Rental Ahmedabad", "Airport Corporate Car Rental Ahmedabad"],
  ["Outstation Corporate Car Hire Ahmedabad", "Chauffeur Driven Car Rental Ahmedabad"],
  ["Staff Transportation Car Rental Ahmedabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental Services in Ahmedabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate car rental services in Ahmedabad, ensuring smooth and efficient transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Ahmedabad’s corporate offices, industrial zones, and business hubs, helping employees reach their workplaces on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Ahmedabad."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate car rental plans to meet the commuting needs of businesses and employees in Ahmedabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking system and reliable coordination, making employee transport hassle-free."
  }
]




































  }

  
const faqData = [
  {
    question: 'Do you provide corporate car rental services in Ahmedabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate car rental services for companies, offices, and events in Ahmedabad.',
  },
  {
    question: 'What types of corporate transportation services do you offer in Ahmedabad?',
    answer: 'We provide employee transportation, airport transfers, corporate pickups and drops, outstation travel, and complete fleet management for businesses.',
  },
  {
    question: 'Do you support daily commute services for corporate employees in Ahmedabad?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, punctual pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate car rental services in Ahmedabad?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate rentals in Ahmedabad?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs based on corporate needs.',
  },
  {
    question: 'Do you offer long-term corporate car rental contracts in Ahmedabad?',
    answer: 'Yes, we provide monthly, quarterly, and annual rental contracts with flexible pricing and complete fleet management solutions.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All our vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure safety.',
  },
  {
    question: 'Do you provide services for night shifts and rotational shifts in Ahmedabad?',
    answer: 'Absolutely. We offer transportation for night shifts, early morning shifts, rotational schedules, and weekend operations.',
  },
  {
    question: 'What payment options are available for corporate car rental services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshad Mehta',
    feedback: 'Reliable corporate car rental service in Ahmedabad. Timely pickups, professional drivers, and clean vehicles every day.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    feedback: 'Excellent service for our corporate travel needs. Flexible plans and well-maintained fleet make commuting smooth.',
    rating: 5,
  },
];











































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental Services in Ahmedabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-rental-ahmedabad.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers premium corporate car rental services in Ahmedabad, including business car hire, employee car rentals, company car leases, monthly corporate rentals, executive and luxury cars, sedan and SUV options, airport transfers, chauffeur-driven services, outstation trips, and full corporate fleet solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rental-ahmedabad"
  }
};







  return (
    <div>
      <Helmet>
  <title>Corporate Car Rental Services in Ahmedabad | Executive & Corporate Cars</title>

  <meta
    name="description"
    content="Premium corporate car rental services in Ahmedabad including business car hire, employee car rentals, company car leases, monthly corporate rentals, executive and luxury cars, sedan & SUV rentals, chauffeur-driven services, airport transfers, and outstation trips."
  />

  <meta
    name="keywords"
    content="Ahmedabad Corporate Car Rental, Business Car Hire Ahmedabad, Employee Car Rental Ahmedabad, Company Car Lease Ahmedabad, Monthly Corporate Car Rental Ahmedabad, Corporate Fleet Ahmedabad, Executive Car Rental Ahmedabad, Sedan Car Rental Ahmedabad, SUV Car Rental Ahmedabad, Luxury Car Rental Ahmedabad, Affordable Corporate Car Rental Ahmedabad, Airport Corporate Car Rental Ahmedabad, Outstation Corporate Car Hire Ahmedabad, Chauffeur Driven Car Rental Ahmedabad, Staff Transportation Car Rental Ahmedabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalserviceinahemdabad;